import {
  giftCardDefaultTypes,
  giftCardServiceProviderTypes,
  giftCardFlipGiveTypes,
  RESTAURANTS_IMG_URL,
  RESTAURANTS_IMG_TITLE,
  configurationPageImages,
  configurationPageTitles,
  configurationPageDescriptions,
  CartItemImages,
  configurationPageServiceCardProgram,
} from '@lib/constants/gift-card-type-constants';
import { getFeatureFlagState } from '@lib/data';
import { featureFlags } from '@lib/constants/network-constants';
import { CARD_PROGRAMS, FLIP_GIVE } from '@lib/constants';
import { LET_THEM_CHOOSE } from '@lib/constants/variants';
import { getFGToken, getReferral } from '@lib/util/local-storage';

const letThemChooseUtil = {
  async getGiftCardTypes(): Promise<string[]> {
    let giftCardTypes: string[] = giftCardDefaultTypes;

    let enableServiceProvider = await getFeatureFlagState(featureFlags.ENABLE_SERVICE_PROVIDERS);
    if (enableServiceProvider) giftCardTypes = giftCardTypes.concat(giftCardServiceProviderTypes);

    const currentRef = getReferral();
    if (currentRef && currentRef === FLIP_GIVE) giftCardTypes = giftCardTypes.concat(giftCardFlipGiveTypes);

    return giftCardTypes;
  },

  getGiftCardImageAndTitle(cardProgram: string) {
    const title = configurationPageTitles[cardProgram] ?? RESTAURANTS_IMG_TITLE;
    const img_url = configurationPageImages[cardProgram] ?? RESTAURANTS_IMG_URL;
    return { title, img_url };
  },

  getDescription(cardProgram: string) {
    return configurationPageDescriptions[cardProgram] ?? CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;
  },

  getCartItemImage(cardProgram: string | undefined) {
    return CartItemImages[cardProgram ?? ''] ?? CartItemImages[CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT];
  },

  getCardProgramForConfigurationPage(ref: string, search: string) {
    if (ref !== FLIP_GIVE) return CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;

    return configurationPageServiceCardProgram[search ?? ''] ?? CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT;
  },

  isFlipGive() {
    const currentRef = getReferral();
    return currentRef === FLIP_GIVE;
  },

  getFlipGiveToken() {
    return getFGToken();
  },

  getBusinessName(
    card_program: string | undefined,
    business_name: string | undefined,
    hasA: boolean = false,
    isYour: boolean = false
  ) {
    if (business_name && business_name != LET_THEM_CHOOSE) return business_name;

    const aText = hasA ? 'a ' : '';
    const yourText = isYour ? 'Your' : 'Their';
    switch (card_program) {
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANTS_SPAS_SALONS:
        return `${aText}Restaurants, Spas and Salons of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT:
        return `${aText}Restaurant of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_SPAS_SALONS:
        return `${aText}Spa or Salon of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_SERVICES:
        return `${aText}Local Service Provider of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_HOME_SERVICES:
        return `${aText}Home Service Provider of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_PERSONAL_SERVICES:
        return `${aText}Personal Service Provider of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_AUTO_SERVICES:
        return `${aText}Auto Service Provider of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT_BARS:
        return `${aText}Bar of ${yourText} Choice`;
      case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT_COFFEE:
        return `${aText}Coffee Shop of ${yourText} Choice`;
      default:
        return business_name;
    }
  },
};

export default letThemChooseUtil;
